module.exports = __webpack_public_path__ + "img/logo.a02ad757.png";